export const MULTIPLE_VALUES_LABEL = "Multiple";
